// gloss
type BrowserAgentInterface = {
  noticeError: (error: Error, customAttributes?: Record<string, unknown>) => void;
  setCustomAttribute: (name: string, value: string | number | boolean) => void;
  addPageAction: (name: string, attributes?: Record<string, unknown>) => void;
};

const getUnderlyingAgent = (): Window['NREUM'] | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window.NREUM || window.newrelic;
};

// gloss
export const browserAgent: BrowserAgentInterface = {
  noticeError: (error, customAttributes) => {
    try {
      const agent = getUnderlyingAgent();
      if (agent?.noticeError) {
        agent.noticeError(error, customAttributes);
      } else if (typeof window !== 'undefined') {
        console.error('Browser error:', error, customAttributes);
      }
    } catch {
    }
  },

  setCustomAttribute: (name, value) => {
    try {
      const agent = getUnderlyingAgent();
      agent?.setCustomAttribute?.(name, value);
    } catch {
    }
  },

  addPageAction: (name, attributes) => {
    try {
      const agent = getUnderlyingAgent();
      if (agent?.addPageAction) {
        agent.addPageAction(name, attributes || {});
      } else if (typeof window !== 'undefined') {
        console.log('Page action:', name, attributes);
      }
    } catch {
    }
  },
};
